
import BreadcrumbView from "../../common/breadcrumb/breadcrumb.html";
import UsersGroupsListView from "./users_groups-list.html";
import UsersGroupsEditView from "./users_groups-edit.html";

angular.module('users_groups', [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('users_groups', {
                url: "/users_groups",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('users_groups.list', {
                url: "/list",
                controller: "usersGroupsListCtrl",
                template: UsersGroupsListView,
                requiredPermission: ["USERS_READ"]
            })

            .state('users_groups.edit', {
                url: "/edit/:id",
                controller: "usersGroupsEditCtrl",
                template: UsersGroupsEditView,
                requiredPermission: ["USERS_WRITE"]
            })

    }])
    ;